
export default {
  breadcrumbs: [],
  adminSetupModules: [],
  modulesSearchQuery: '',
  selectedDataModelNode: null
}
